import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind classes safely. Last conflicting class wins.
 *   cn('p-4', 'p-6')        -> 'p-6'
 *   cn('p-4', isActive && 'bg-primary')
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
